export default {
    root: {
        margin: 0,
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
        alignItems: 'baseline',

        '.MuiTypography-root': {
            paddingRight: '10px',
        },
    },
    inputField: {
        display: 'flex',
        alignItems: 'center',
    },
    extraText: {
        paddingLeft: '10px',
    },
};
